import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// ── Kill the Create React App "Script error." dev overlay ──────────
// This overlay appears when third-party payment scripts (Korapay/Paystack)
// throw cross-origin errors. It is purely a development annoyance —
// it never appears in production. We remove it from the DOM as soon
// as it mounts.
// Suppress the CRA webpack dev overlay ONLY — not payment iframes
const killOverlay = () => {
  const overlay = document.getElementById('webpack-dev-server-client-overlay');
  if (overlay) overlay.remove();
  // Only remove divs with the CRA overlay class — NOT iframes (Paystack uses iframes)
  document.querySelectorAll('div[id="webpack-dev-server-client-overlay-div"]').forEach(el => el.remove());
};

// Watch for the overlay being added to the DOM
const observer = new MutationObserver(killOverlay);
observer.observe(document.body, { childList: true, subtree: true });

// Also suppress the error event itself
window.addEventListener('error', (e) => {
  if (e.message === 'Script error.' || e.message === 'Script error') {
    e.stopImmediatePropagation();
    e.preventDefault();
    killOverlay();
    return false;
  }
}, true);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);